import React, { useState } from 'react';
import { ChevronDownIcon, CalendarIcon } from 'lucide-react';
export const InsightsSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const blogPosts = [{
    id: 1,
    title: 'Understanding Digital Forensics in Modern Investigations',
    date: 'March 15, 2024',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }, {
    id: 2,
    title: 'The Role of Private Investigators in Corporate Due Diligence',
    date: 'March 8, 2024',
    excerpt: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  }, {
    id: 3,
    title: 'Best Practices for Surveillance Evidence Documentation',
    date: 'February 28, 2024',
    excerpt: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.'
  }];
  return <section className="w-full bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800" data-id="element-249">
      {/* Collapsible Header Bar */}
      <button onClick={() => setIsExpanded(!isExpanded)} className="w-full h-[100px] flex items-center justify-between px-8 hover:bg-white/5 transition-colors duration-300 group" data-id="element-250">
        <div className="flex items-center gap-4" data-id="element-251">
          <div className="w-1 h-16 bg-kgi-red rounded-full" data-id="element-252"></div>
          <div className="text-left" data-id="element-253">
            <h2 className="font-serif text-3xl font-bold text-white mb-1" data-id="element-254">
              Investigative Insights & Articles
            </h2>
            <p className="text-blue-100 text-sm" data-id="element-255">
              Expert perspectives on investigation best practices and industry
              trends
            </p>
          </div>
        </div>
        <ChevronDownIcon className={`h-8 w-8 text-white transition-transform duration-500 ease-out ${isExpanded ? 'rotate-180' : ''}`} data-id="element-256" />
      </button>

      {/* Expandable Content */}
      <div className={`overflow-hidden transition-all duration-500 ease-out ${isExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-257">
        <div className="container mx-auto px-8 pb-16 pt-8" data-id="element-258">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-259">
            {blogPosts.map((post, index) => <article key={post.id} className="bg-white rounded-lg p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1" style={{
            animation: isExpanded ? `slideUp 0.5s ease-out ${index * 0.1}s both` : 'none'
          }} data-id="element-260">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3" data-id="element-261">
                  <CalendarIcon className="h-4 w-4" data-id="element-262" />
                  <span data-id="element-263">{post.date}</span>
                </div>
                <h3 className="font-serif text-xl font-bold text-kgi-blue-900 mb-3 leading-tight" data-id="element-264">
                  {post.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4" data-id="element-265">
                  {post.excerpt}
                </p>
                <a href="#" className="inline-flex items-center text-kgi-red font-semibold text-sm hover:text-kgi-red-600 transition-colors" data-id="element-266">
                  Read More
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-267">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-268" />
                  </svg>
                </a>
              </article>)}
          </div>
        </div>
      </div>

      <style data-id="element-269">{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>;
};